export default __webpack_public_path__ + "dda51534698bfd3ee445a44949955e65.png";